import React, { useEffect } from 'react'

const SEOMetaTags = ({ 
  title, 
  description, 
  keywords, 
  canonical, 
  ogTitle, 
  ogDescription, 
  ogImage, 
  ogUrl,
  structuredData,
  additionalMeta = []
}) => {
  const siteTitle = "NorCal Cane Corso Puppies"
  const siteDomain = "https://norcalcanecorsopuppies.com"
  const defaultImage = `${siteDomain}/images/og-default.jpg`
  
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle
  const fullDescription = description || "Premium Cane Corso puppies in Northern California. Beautiful, well-bred Italian Mastiff puppies with health guarantees and easy inquiry process."
  const fullKeywords = keywords || "Cane Corso, puppies, dogs, Italian Mastiff, breeding, sale, Northern California, AKC registered, health guarantee"
  
  useEffect(() => {
    // Update document title
    document.title = fullTitle
    
    // Helper function to update or create meta tags
    const updateMetaTag = (property, content, name = null) => {
      let selector = name ? `meta[name="${property}"]` : `meta[property="${property}"]`
      let element = document.querySelector(selector)
      
      if (!element) {
        element = document.createElement('meta')
        if (name) {
          element.setAttribute('name', property)
        } else {
          element.setAttribute('property', property)
        }
        document.head.appendChild(element)
      }
      element.setAttribute('content', content)
    }
    
    // Update basic meta tags
    updateMetaTag('description', fullDescription, true)
    updateMetaTag('keywords', fullKeywords, true)
    updateMetaTag('robots', 'index, follow', true)
    updateMetaTag('language', 'English', true)
    updateMetaTag('author', 'NorCal Cane Corso Puppies', true)
    
    // Update Open Graph meta tags
    updateMetaTag('og:title', ogTitle || fullTitle)
    updateMetaTag('og:description', ogDescription || fullDescription)
    updateMetaTag('og:image', ogImage || defaultImage)
    updateMetaTag('og:url', ogUrl || `${siteDomain}${canonical || ''}`)
    updateMetaTag('og:type', 'website')
    updateMetaTag('og:site_name', siteTitle)
    updateMetaTag('og:locale', 'en_US')
    
    // Update Twitter Card meta tags
    updateMetaTag('twitter:card', 'summary_large_image', true)
    updateMetaTag('twitter:title', ogTitle || fullTitle, true)
    updateMetaTag('twitter:description', ogDescription || fullDescription, true)
    updateMetaTag('twitter:image', ogImage || defaultImage, true)
    updateMetaTag('twitter:site', '@norcalcanecorso', true)
    updateMetaTag('twitter:creator', '@norcalcanecorso', true)
    
    // Update additional SEO meta tags
    updateMetaTag('theme-color', '#2c3e50', true)
    updateMetaTag('msapplication-TileColor', '#2c3e50', true)
    updateMetaTag('apple-mobile-web-app-capable', 'yes', true)
    updateMetaTag('apple-mobile-web-app-status-bar-style', 'black-translucent', true)
    
    // Update geo tags for local SEO
    updateMetaTag('geo.region', 'US-CA', true)
    updateMetaTag('geo.placename', 'Northern California', true)
    updateMetaTag('geo.position', '38.7783;-121.302', true)
    updateMetaTag('ICBM', '38.7783, -121.302', true)
    
    // Handle canonical URL
    if (canonical) {
      let canonicalElement = document.querySelector('link[rel="canonical"]')
      if (!canonicalElement) {
        canonicalElement = document.createElement('link')
        canonicalElement.setAttribute('rel', 'canonical')
        document.head.appendChild(canonicalElement)
      }
      canonicalElement.setAttribute('href', `${siteDomain}${canonical}`)
    }
    
    // Handle additional meta tags
    additionalMeta.forEach(meta => {
      if (meta.name) {
        updateMetaTag(meta.name, meta.content, true)
      } else if (meta.property) {
        updateMetaTag(meta.property, meta.content)
      }
    })
    
    // Handle structured data
    if (structuredData) {
      let existingScript = document.querySelector('script[type="application/ld+json"]')
      if (existingScript) {
        existingScript.remove()
      }
      
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.textContent = JSON.stringify(structuredData)
      document.head.appendChild(script)
    }
  }, [title, description, keywords, canonical, ogTitle, ogDescription, ogImage, ogUrl, structuredData, additionalMeta, fullTitle, fullDescription, fullKeywords, siteDomain, defaultImage, siteTitle])
  
  return null // This component doesn't render anything
}

export default SEOMetaTags